import * as React from "react"
import { ThemeCss } from "gatsby-interface"
import { StandardSingleColumn } from "@modules/ui/layouts/Containers"

const containerCss: ThemeCss = theme => ({
  display: `grid`,
  gridRowGap: theme.space[5],
  paddingTop: theme.space[2],
  paddingBottom: theme.space[5],
})

type CommonProps = {
  children?: React.ReactNode
}

export function SiteInformationViewLayout({ children }: CommonProps) {
  return <div>{children}</div>
}

export function SiteInformationViewHeader({ children }: CommonProps) {
  return <StandardSingleColumn>{children}</StandardSingleColumn>
}

export function SiteInformationViewBanners({ children }: CommonProps) {
  return <section css={containerCss}>{children}</section>
}

const gridCss: ThemeCss = theme => ({
  display: `grid`,
  gridTemplateColumns: `1fr`,
  gridTemplateRows: `max-content max-content max-content`,
  gridGap: theme.space[3],
  gridTemplateAreas: `
    "siteName"
    "description"
    "details"
  `,
})

const gridWrapperCss: ThemeCss = theme => ({
  display: `grid`,
  alignItems: `flex-end`,
  gridGap: theme.space[9],
  [theme.mediaQueries.desktop]: {
    gridGap: theme.space[5],
    gridTemplateColumns: `1fr 1fr`,
  },
})

const siteHostingWrapperCss: ThemeCss = theme => ({
  display: `flex`,
  flexDirection: `column`,
  gap: theme.space[3],
  [theme.mediaQueries.desktop]: {
    justifyContent: `flex-end`,
    alignItems: `flex-end`,
    gap: theme.space[5],
  },
})

export function SiteInformationViewGrid(props: CommonProps) {
  return <div css={gridCss} {...props} />
}

export function SiteInformationViewGridWrapper(props: CommonProps) {
  return <div css={gridWrapperCss} {...props} />
}

export function SiteHostingLimitsWrapper(props: CommonProps) {
  return <div css={siteHostingWrapperCss} {...props} />
}

const siteNameAreaCss: ThemeCss = _theme => ({ gridArea: "siteName" })

export function SiteInformationViewSiteNameArea(props: CommonProps) {
  return <div css={siteNameAreaCss} {...props} />
}

const descriptionAreaCss: ThemeCss = _theme => ({ gridArea: "description" })

export function SiteInformationViewDescriptionArea(props: CommonProps) {
  return <div css={descriptionAreaCss} {...props} />
}

const detailsAreaCss: ThemeCss = theme => ({
  margin: `${theme.space[3]} 0`,
  gridArea: `details`,
  display: `grid`,
  gridGap: theme.space[7],
  alignItems: `center`,
  [theme.mediaQueries.tablet]: {
    gridTemplateColumns: `max-content`,
  },
  [theme.mediaQueries.desktop]: {
    gridTemplateColumns: `auto max-content`,
  },
})

export function SiteInformationViewDetailsArea(props: CommonProps) {
  return <div css={detailsAreaCss} {...props} />
}
